import React , {useState , useRef} from 'react';
import { Box, CircularProgress, Stack, Card, Typography , Button , Modal, styled, TooltipProps, tooltipClasses} from '@mui/material';
import { useSalesContext } from '../../../Pages/SalesContext';
import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import "../css/BreakwiseData.css";
import {  Tooltip } from '@mui/material';
import checkIcon from "../../../assets/images/check.svg";
import slashCircle from "../../../assets/images/slash-circle-01.svg";
import gridDot from "../../../assets/images/grid-dots-blank.svg";

interface CardData {
  [key: string]: string[];
}

interface KPIData {
  kpi_data: {
    card1Data: CardData;
    card2Data: CardData;
  };
}

interface SalesContext {
  kpiData: KPIData | null;
  salesUnit: string;
  loading: boolean;
}
const BreakwiseDataComponent: React.FC = React.memo(() => {

  const { kpiData, salesUnit, loading } = useSalesContext();
  const [filteredData, setFilteredData] = useState({
    card1_data: [],
    card2_data: []
  });
  const [open, setOpen] = useState(false);
  const buttonRefs = useRef([]);

  useEffect(() => {
    if (kpiData) {
      setFilteredData({
        card1_data: kpiData.card1_data || [],
        card2_data: kpiData.card2_data || []
      });
    }
  }, [kpiData]);

  if (loading || !kpiData) {
    return (
      <Box sx={{ p: 2, display: "flex", justifyContent: "center", alignItems: "center" }}>
        <CircularProgress />
      </Box>
    );
  }

  const cardConfig = [
    {
      title: `Top 3 Saleable return SKU (${salesUnit || "Lacs"})`,
      color: "#E2F6FF",
      data: filteredData.card1_data.map(item => ({
        name: item.ItemName,
        return: item.Return_Sales,
        itemCode: item.ItemCode,
      })),
    },
    {
      title: `Top 3 Non-Saleable return SKU (${salesUnit || "Lacs"})`,
      color: "#FDECEF",
      data: filteredData.card2_data.map(item => ({
        name: item.ItemName,
        expiry: item.Expiry_Sales,
        itemCode: item.ItemCode,
      })),
    },
  ];

  const adjustValue = (numValue, salesUnit) => {
    if (!isFinite(numValue) && !isNaN(numValue)) {
      return "0";
    }

    if (isNaN(numValue)) {
      return 0;
    }

    let adjustedValue;
    if (salesUnit === "Lacs") {
      adjustedValue = numValue / 100000;
    } else if (salesUnit === "Crores") {
      adjustedValue = numValue / 10000000; 
    } else {
      adjustedValue = numValue;
    }

    return adjustedValue.toFixed(3); 
  };

  const handleKeep = (itemCode, cardType) => {
    setFilteredData(prevData => {
      let newCard1Data = prevData.card1_data;
      let newCard2Data = prevData.card2_data;
  
      if (cardType === 'card1') {
        newCard1Data = prevData.card1_data.filter(item => item.ItemCode === itemCode);
      } else if (cardType === 'card2') {
        newCard2Data = prevData.card2_data.filter(item => item.ItemCode === itemCode);
      }
  
      console.log('Keep:', newCard1Data, newCard2Data); // Debugging
      return {
        ...prevData,
        card1_data: newCard1Data,
        card2_data: newCard2Data,
      };
    });
  };
  

  const handleExclude = (itemCode, cardType) => {
    setFilteredData(prevData => {
      let newCard1Data = prevData.card1_data;
      let newCard2Data = prevData.card2_data;
  
      if (cardType === 'card1') {
        newCard1Data = prevData.card1_data.filter(item => item.ItemCode !== itemCode);
      } else if (cardType === 'card2') {
        newCard2Data = prevData.card2_data.filter(item => item.ItemCode !== itemCode);
      }
  
      console.log('Exclude:', newCard1Data, newCard2Data); // Debugging
      return {
        ...prevData,
        card1_data: newCard1Data,
        card2_data: newCard2Data,
      };
    });
  };
  
  const getYesterdayDate = () => {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

 
    const options = { day: "2-digit", month: "short", year: "2-digit" };
    return yesterday.toLocaleDateString("en-GB", options).replace(/ /g, "-");
  };
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#f5f5f9',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 220,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #dadde9',
    },
  }));
  return (
    <Box sx={{ p: 2 }} className="breakwise-container2">
       <Box className="header">
              <Box className="title-container">
                <Typography className="Filter-title" sx={{ fontSize: "14px" }}>
                  Data Till Date {getYesterdayDate()}
                </Typography>
              </Box>
            </Box>
      <Stack direction={{ xs: "column", sm: "row"  }}>
        {cardConfig.map((sale, index) => (
          <Card
            className="breakwise-container"
            key={index}
            sx={{
              backgroundColor: sale.color,
              boxShadow: "none",
              marginRight: index % 2 === 0 ? "16px" : "0",
              marginTop :"10px"
            }}
          >
            <Box className="breakwise-item">
              <Typography className="breakwise-title-text-2" fontWeight="bold">
                {sale.title}
              </Typography>
            </Box>

            <Stack className="mt-4" sx={{ marginRight: "0", marginLeft: "0", marginTop: "20px" }}>
              {sale.data.map((tablet, idx) => (
                <Stack key={idx} direction="row" sx={{ width: "100%" }}>
                  <HtmlTooltip
                    title={
                      <div className="custom-tooltip">
                        <div className='breakwise-modal-content'>
                        <Button className='keep-button' onClick={() => handleKeep(tablet.itemCode, index === 0 ? 'card1' : 'card2')}>
                          <img src={checkIcon} alt="Keep" className="breakwise-keep"/> Keep
                          </Button>
                         <Button className='exclude-button' onClick={() => handleExclude(tablet.itemCode, index === 0 ? 'card1' : 'card2')}>
                          <img src={slashCircle} alt="exclude"  className="breakwise-exclude"/>  Exclude
                          </Button>
                        </div>
                        <div className="tablet-info-box">
                          <div className="tablet-breakwise-button-2"> {tablet.name}</div>
                        </div>
                      </div>
                    }
                    arrow
                  >
                    <Button className="tablet-breakwise-button-2">{tablet.name} </Button>
                  </HtmlTooltip>

                  <Box sx={{ flexGrow: 1 }} />
                  <HtmlTooltip
                    title={
                      <div className="custom-tooltip">
                        <div className='breakwise-modal-content'>
                        <Button className='keep-button' onClick={() => handleKeep(tablet.itemCode, index === 0 ? 'card1' : 'card2')}>
                          <img src={checkIcon} alt="Keep" className="breakwise-keep"/> Keep
                          </Button>
                         <Button className='exclude-button' onClick={() => handleExclude(tablet.itemCode, index === 0 ? 'card1' : 'card2')}>
                          <img src={slashCircle} alt="exclude"  className="breakwise-exclude"/>  Exclude
                          </Button>
                        </div>
                        <div className="tablet-info-box">
                          <div className=""><span className='bold-text'>Item Name :</span> {tablet.name}</div>
                          <div className=""> <span className='bold-text'>Item_Code: </span>{tablet.itemCode} </div>
                          <div className="">                        
{tablet.return !== undefined ? <span className='bold-text'>Return Amount: </span> : <span className='bold-text'>Expiry Amount: </span>}
 {tablet.return !== undefined ? tablet.return : tablet.expiry}

                          </div>
                        </div>
                      </div>
                    }
                    arrow
                  >
                    <Button className="tablet-breakwise-button-2">
                      {adjustValue(tablet.return || tablet.expiry, salesUnit)}
                    </Button>
                  </HtmlTooltip>
                </Stack>
              ))}
            </Stack>
          </Card>
        ))}
      </Stack>
    </Box>
  );
});

export default BreakwiseDataComponent;




